// packages/web-ui/src/AppShell/ContextPanel-modes/FilesMode.tsx
//
// W2-S3 Task 7.2 (AC #5/#6) — Files destination context-panel body.
// W3 fix-pass HIGH-5 — wires `<FilesPanel>` (W3-S5) into the AppShell. The
// W2-S3 placeholder chrome (filter chips + empty-state copy) was the only
// thing rendered before; now `<FilesPanel>` ships the full file-tree
// surface (search, chip filter, three-state body, context menu, inline
// rename, virtualisation).

import type { JSX } from 'react';
import { FilesPanel } from '../../panels/files/index.js';
import { useCapabilities } from '../../hooks/useCapabilities.js';
import { useOpenResource } from '../../hooks/useOpenResource.js';

export function FilesMode(): JSX.Element {
  const { capabilities, openInSyside } = useCapabilities();
  const sysideAvailable = capabilities?.hasSyside === true;
  const openResource = useOpenResource();

  return (
    <div data-testid="files-mode-root" className="flex h-full flex-col">
      <FilesPanel
        sysideAvailable={sysideAvailable}
        onOpen={(path) => {
          openResource('files', path);
        }}
        onOpenInSyside={(path) => {
          void openInSyside({ path });
        }}
      />
    </div>
  );
}
